import {Container, Grid} from "@mui/material";
import React from "react";
import Typography from "@mui/material/Typography";

export default function WelcomeCard({userInfo}) {
    return (
        <Container maxWidth="lg">
            <Grid container direction="column" spacing={3} alignItems={"center"} justifyContent={"center"}>
                <Grid item xs>
                    <Typography variant="h3" component="h3" align="center">
                        Welcome aboard! <br/> <strong>{userInfo['firstname']} {userInfo['lastname']}</strong>
                    </Typography>
                </Grid>
            </Grid>
        </Container>
    );
}